module.exports = "/_next/static/media/e4f15af4bd85303bbfa85f253d0d7ac3.png";